export abstract class Component {
  constructor(public blazorElement: any, public element: HTMLElement) {}

  abstract initialize(); 
}
